import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home.jsx";
import Contact from "./pages/Contact.jsx";
import Services from "./pages/Services.jsx";
import About from "./pages/About.jsx";
import Work from "./pages/Work.jsx";
import Nav from "../src/components/Nav.jsx";
import Footer from "./components/Footer.jsx";
import Foodapp from "./components/work/Projectpages/Foodapp.jsx";
import Eventsapp from "./components/work/Projectpages/Eventsapp.jsx";
import Ticktok from "./components/work/Projectpages/Ticktok.jsx";
import Voiceapp from "./components/work/Projectpages/Voiceapp.jsx";
import "../src/app.css";

function App() {
    return (
        <div className="bg-sectionBackground h-screen">
            <Router>
                <Nav />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/work" element={<Work />} />
                    <Route path="/work/food-app" element={<Foodapp />} />
                    <Route path="/work/events-app" element={<Eventsapp />} />
                    <Route path="/work/ticktok" element={<Ticktok />} />
                    <Route path="/work/voice-app" element={<Voiceapp />} />
                </Routes>
                {/*<Footer/>*/}
            </Router>
        </div>
    );
}

export default App;
